export function validateTextAlignment(value: unknown): boolean {
    return (
        value === 'start' || value === 'center' || value === 'end' || typeof value === 'undefined'
    );
}
